if (!customElements.get('live-viewers')) {
  customElements.define(
    'live-viewers',
    class LiveViewers extends HTMLElement {
      connectedCallback() {
        this.countEl = this.querySelector('.live-viewers__count');
        this.labelEl = this.querySelector('[data-live-viewers-label]');
        this.min = parseInt(this.dataset.min, 10) || 1;
        this.max = parseInt(this.dataset.max, 10) || this.min;

        this.scheduleNudge();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      scheduleNudge() {
        // Randomized interval so multiple product cards on one page don't
        // all tick in lockstep.
        const delay = 15000 + Math.random() * 20000;
        this.timer = setTimeout(() => {
          this.nudge();
          this.scheduleNudge();
        }, delay);
      }

      nudge() {
        if (!this.countEl) return;
        const current = parseInt(this.countEl.textContent, 10) || this.min;
        const direction = Math.random() < 0.5 ? -1 : 1;
        let next = current + direction;
        if (next < this.min) next = this.min + 1 <= this.max ? this.min + 1 : this.min;
        if (next > this.max) next = this.max - 1 >= this.min ? this.max - 1 : this.max;

        this.countEl.textContent = next;
        if (this.labelEl) {
          this.labelEl.textContent = next === 1 ? 'person is viewing this product' : 'people are viewing this product';
        }
      }
    }
  );
}
